/**
 * Infinite scroll
 */

import { observeAnimatedBlocks } from '../layout/animations.js';

export default function initInfiniteScroll() {
	const archiveContainer = document.querySelector("[data-infinite-scroll]");
	if ( !archiveContainer ) return;

	const postType = archiveContainer.getAttribute("data-infinite-scroll");
	const postContainer = document.getElementById("post-container");
	const loader = document.getElementById("load-more");

	const ajaxurl = '/wp-admin/admin-ajax.php';
	const queryVars = JSON.parse(archiveContainer.getAttribute("data-query-vars"));
	let currentPage = parseInt(archiveContainer.getAttribute("data-current-page"));
	const maxPage = parseInt(archiveContainer.getAttribute("data-max-page"));
	let isLoading = false;

	function setLoaderState( state, text ){
		// Clear all status classes first
		loader.classList.remove("is-loading", "is-error", "is-loaded");
		if ( state ) loader.classList.add(state);
		if ( text!==undefined ) loader.textContent = text;
	}

	function loadMorePosts(){
		if ( isLoading || currentPage>=maxPage ) return;

		isLoading = true;
		setLoaderState("is-loading", "Loading more posts...");

		const formData = new FormData();
		formData.append("action", "cs__load_more_posts");
		formData.append("page", currentPage);
		formData.append("query_vars", JSON.stringify(queryVars));
		formData.append("post_type", postType);

		fetch(ajaxurl, {
			method: "POST",
			credentials: "same-origin",
			body: formData,
		})
		.then(( res ) => res.text())
		.then(( data ) => {
			if ( data.trim() ){
				postContainer.insertAdjacentHTML("beforeend", data);
				observeAnimatedBlocks();
				
				currentPage++;
				archiveContainer.setAttribute("data-current-page", currentPage);
				isLoading = false;

				if ( currentPage>=maxPage ){
					setLoaderState("is-loaded", "All posts loaded");
				} else {
					// Reset loader state (remove loading class and keep default or empty text)
					setLoaderState(null, "");
				}
			} else {
				setLoaderState("is-loaded", "All posts loaded");
			}
		})
		.catch(( err ) => {
			console.error("Error loading more posts:", err);
			setLoaderState("is-error", "Error loading posts");
		});
	}

	window.addEventListener("scroll", () => {
		const scrollPos = window.scrollY + window.innerHeight;
		const triggerPoint = document.body.offsetHeight - 1000;

		if ( scrollPos>=triggerPoint && !isLoading ){
			loadMorePosts();
		}
	});
}